// Shared compact admin UI primitives.
export const inputCls =
  "w-full rounded-lg border border-slate-300 bg-white px-3 py-2 text-sm text-ink-body focus:outline-none focus:ring-2 focus:ring-azeka-teal focus:border-azeka-teal";

export const Field = ({ label, children }) => (
  <label className="block">
    <span className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-ink-muted">{label}</span>
    {children}
  </label>
);

export const Input = (props) => <input {...props} className={inputCls} />;
export const Textarea = (props) => <textarea {...props} className={inputCls} />;

export const Panel = ({ title, actions, children, testid }) => (
  <section data-testid={testid} className="rounded-xl border border-slate-200 bg-white">
    {(title || actions) && (
      <div className="flex items-center justify-between border-b border-slate-100 px-5 py-4">
        <h2 className="text-base font-semibold text-ink-heading">{title}</h2>
        <div className="flex items-center gap-2">{actions}</div>
      </div>
    )}
    <div className="p-5">{children}</div>
  </section>
);

export const Btn = ({ variant = "primary", className = "", ...props }) => {
  const styles = {
    primary: "bg-azeka-navy text-white hover:bg-azeka-navy2",
    teal: "bg-azeka-teal text-white hover:bg-azeka-teal2",
    ghost: "bg-transparent text-ink-body hover:bg-slate-100 border border-slate-300",
    danger: "bg-red-600 text-white hover:bg-red-700",
  }[variant];
  return (
    <button
      {...props}
      className={`inline-flex items-center justify-center gap-2 rounded-lg px-4 py-2 text-sm font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${styles} ${className}`}
    />
  );
};

const STATUS_COLORS = {
  new: "bg-amber-100 text-amber-800",
  in_review: "bg-blue-100 text-blue-800",
  closed: "bg-slate-200 text-slate-700",
  published: "bg-emerald-100 text-emerald-800",
  draft: "bg-slate-200 text-slate-700",
  active: "bg-emerald-100 text-emerald-800",
  coming_soon: "bg-amber-100 text-amber-800",
  in_development: "bg-blue-100 text-blue-800",
};

export const Badge = ({ status }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${STATUS_COLORS[status] || "bg-slate-100 text-slate-700"}`}>
    {String(status || "").replace(/_/g, " ")}
  </span>
);

export const Th = ({ children }) => (
  <th className="px-4 py-3 text-left text-xs font-semibold uppercase tracking-wide text-ink-muted">{children}</th>
);
export const Td = ({ children, className = "" }) => (
  <td className={`px-4 py-3 text-sm text-ink-body ${className}`}>{children}</td>
);
